import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=288a90d5&"
import script from "./PasswordLogin.vue?vue&type=script&lang=ts&"
export * from "./PasswordLogin.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&id=288a90d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports